module.exports = __webpack_public_path__ + "img/55.1.d78d54d9.jpg";